export const MESSAGE_PROPERTY_SET_ID = '41f28f13-83f4-4114-a584-eedb5a6b0bff';
export const COPILOT_DRAFT_GENERATION_PROPERTIES_NAME = 'CopilotDraftGenerationProperties';
export const OUTLOOK_MCP_DRAFT_SOURCE = 'OutlookMcp';
